module.exports = __webpack_public_path__ + "static/media/EOSWHITE.726f9afd.svg";